import { Platform, StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  editContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 5,
  },
  editText: {
    fontSize: 16,
    marginRight: 8,
    ...Platform.select({
      ios: {
        marginTop: 3,
      },
    }),
  },
  upgradeSelection: {
    ...Fonts.type.bold,
    fontSize: 25,
    flex: 1,
  },
});

export default styles;
